import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Note: React.StrictMode is intentionally not used here because react-leaflet's
// MapContainer doesn't survive StrictMode's double-mount in development mode
// ("Map container is already initialized" error).
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
